import { render, staticRenderFns } from "./ButtonShowRegistry.vue?vue&type=template&id=25eb1485&"
import script from "./ButtonShowRegistry.vue?vue&type=script&lang=js&"
export * from "./ButtonShowRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports